import { Suspense } from "react";
import { Redirect } from "react-router-dom";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { settingsNavPathV3 } from "@circle-react/helpers/urlHelpers/settingsNavPathV3";
import { usePlanStatus } from "@circle-react/hooks/usePlanStatus";
import { PageLoader } from "@circle-react/pages/PageLoader";

const BrandedAppsComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "BrandedAppsDashboardPage" */ "@circle-react/components/SettingsApp/BrandedAppsDashboard/index"
    ),
);

export const BrandedAppsDashboardPage = () => {
  const { isCommunityOnPlus } = usePlanStatus();

  if (!isCommunityOnPlus) {
    return <Redirect to={settingsNavPathV3.plans.brandedApps} />;
  }

  return (
    <Suspense fallback={<PageLoader />}>
      <BrandedAppsComponent />
    </Suspense>
  );
};
